/* eslint-disable react-hooks/immutability */

import { type RowData, type TableOptions } from '@tanstack/react-table';

import { useDataTableConfigElement } from '../../../hooks/useDataTableConfig.js';
import type { TDataTableFeatures } from '../types/features.types.js';

export function useLayout<
  TFeatures extends TDataTableFeatures,
  TData extends RowData,
>(
  props: { fullWidth?: boolean; fullHeight?: boolean },
  options: TableOptions<TFeatures, TData>,
): void {
  const configFullWidth = useDataTableConfigElement('fullWidth');
  const configFullHeight = useDataTableConfigElement('fullHeight');

  options.layout = {
    ...options.layout,
    fullWidth: props.fullWidth ?? configFullWidth,
    fullHeight: props.fullHeight ?? configFullHeight,
  };
}
